import { useCallback } from 'react'
import shoppingCartV2API from '../../../../../api'
import { useShoppingCartContext } from '../../../../../providers/ShoppingCartProvider'
import useVehicleController from '../../../../../../../controllers/vehicle.controller'
import nrLogger from '../../../../../../../helpers/nrLogger'

const useUpdateVehicle = param => {
  const {
    cartVehicleDB, product, shouldShowSpinner,
  } = param

  const { updateVehicles } = useVehicleController()

  const {
    getCartId,
    getIdentifier,
    setCart,
  } = useShoppingCartContext()

  return useCallback(
    async () => {
      if (cartVehicleDB.itemId !== product.productId) {
        return
      }

      try {
        shouldShowSpinner(true)

        const {
          vehicleType, year, make, model, submodel, engine,
        } = cartVehicleDB

        const items = [
          {
            product: {
              productId: product.productId,
            },
            modifiers: {
              vehicle: {
                details: {
                  ...(vehicleType && { vehicleType }),
                  year,
                  make,
                  model,
                  submodel,
                  engine,
                },
              },
            },
          },
        ]

        const identifier = getIdentifier()
        const cartId = getCartId()
        const res = await shoppingCartV2API.vehicles.update(identifier, cartId, items)
        setCart(res)

        updateVehicles({ cartVehicleDB: {} })
        shouldShowSpinner(false)
      } catch (error) {
        nrLogger.error('ShoppingCartV2.VehicleFitment.useUpdateVehicle.error', error)
        shouldShowSpinner(false)
      }
    },
    [
      cartVehicleDB,
      getCartId,
      getIdentifier,
      updateVehicles,
      setCart,
      product,
      shouldShowSpinner,
    ],
  )
}

export default useUpdateVehicle
